<h2 mat-dialog-title>{{ isEditMode() ? 'Edytuj koszt' : 'Dodaj koszt' }}</h2>
@if (saving()) {
	<mat-dialog-content class="pt-3">
		<div class="d-flex justify-content-center align-items-center dialog-square">
			<mat-spinner></mat-spinner>
		</div>
	</mat-dialog-content>
} @else {
	<mat-dialog-content class="pt-3">
		<form [formGroup]="form">
			<div class="row mb-1 align-items-start">
				<div class="col-md-8">
					@if (!isEditMode()) {
						<app-generic-mat-autocomplete
							[apiUrl]="productCostsApiUrl"
							[apiSearchParam]="'search'"
							[placeholder]="'Nazwa'"
							[idKey]="'id'"
							[displayKeys]="['name']"
							[responseMapper]="productCostResponseMapper"
							[required]="true"
							(selected)="onCostSelected($event)"
						></app-generic-mat-autocomplete>
					} @else {
						<mat-form-field [appearance]="appearance" class="w-100">
							<mat-label>Nazwa</mat-label>
							<input matInput formControlName="name" />
							@if (form.get('name')?.hasError('required') && form.get('name')?.touched) {
								<mat-error>To pole jest wymagane</mat-error>
							}
						</mat-form-field>
					}
				</div>
				<div class="col-md-4 d-flex flex-column">
					<mat-slide-toggle formControlName="isFaculty" color="primary" class="mt-3"
						>Czy fakultet?</mat-slide-toggle
					>
				</div>
			</div>
			<div class="row mb-1">
				<div class="col-md-6">
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>Rodzaj</mat-label>
						<mat-select formControlName="kind" [compareWith]="compareKind">
							@for (kindOption of kindOptions(); track kindOption.id) {
								<mat-option [value]="kindOption">{{ kindOption.name }}</mat-option>
							}
						</mat-select>
						@if (form.get('kind')?.hasError('required') && form.get('kind')?.touched) {
							<mat-error>To pole jest wymagane</mat-error>
						}
					</mat-form-field>
				</div>
				<div class="col-md-6">
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>Waluta</mat-label>
						<mat-select formControlName="currency">
							@for (currency of currencies(); track currency.id) {
								<mat-option [value]="currency.id">{{ currency.name }}</mat-option>
							}
						</mat-select>
						@if (form.get('currency')?.hasError('required') && form.get('currency')?.touched) {
							<mat-error>To pole jest wymagane</mat-error>
						}
					</mat-form-field>
				</div>
			</div>
			<div class="row mb-1">
				<div class="col-md-6">
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>Metoda</mat-label>
						<mat-select formControlName="method">
							@for (methodOption of methodOptions; track methodOption.value) {
								<mat-option [value]="methodOption.value">{{ methodOption.label }}</mat-option>
							}
						</mat-select>
						@if (form.get('method')?.hasError('required') && form.get('method')?.touched) {
							<mat-error>To pole jest wymagane</mat-error>
						}
					</mat-form-field>
				</div>
				<div class="col-md-6">
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>X</mat-label>
						<input matInput type="number" formControlName="fixedCapacity" />
					</mat-form-field>
				</div>
			</div>
			<div class="row mb-1">
				<div class="col-md-12">
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>Uwagi</mat-label>
						<textarea matInput formControlName="note" rows="3"></textarea>
					</mat-form-field>
				</div>
			</div>
		</form>
	</mat-dialog-content>
}
<mat-dialog-actions align="end">
	<button mat-raised-button (click)="cancel()" [disabled]="saving()">Anuluj</button>
	<button mat-raised-button color="primary" [disabled]="form?.invalid || saving()" (click)="save()">
		{{ isEditMode() ? 'Zapisz' : 'Dodaj' }}
	</button>
</mat-dialog-actions>
